// extracted by extract-css-chunks-webpack-plugin
module.exports = {"events":"_1SohE7 aLs3Nr","headerWrapper":"_3gyLOT","subtitle":"aXXAj5","linkWrapper":"_2XK3nK"};